<template>
  <v-container fluid>
    <div style="margin-top:200px;"></div>
    <div style="text-align:center;">
      <v-row no-gutters>
        <v-col cols="12">
          <span style="font-size:28px;font-weight:bold;">
            PACKING LIST
          </span>
        </v-col>
        <v-col cols="6">
          <span class="titulos bgg">
            Customer Order No:
          </span>
          <span class="subtitulos">32132</span>
        </v-col>
        <v-col cols="6">
          <span class="titulos bgg">
            Date shipped:
          </span>
          <span class="subtitulos">32132</span>
        </v-col>
        <v-col cols="6">
          <span class="titulos bgg">
            Ship to:
          </span>
          <span class="subtitulos">32132</span>
        </v-col>
        <v-col cols="6">
          <span class="titulos bgg">
            AWB
          </span>
          <span class="subtitulos">32132</span>
        </v-col>
      </v-row>
      <v-row no-gutters class="mt-2">
        <v-col cols="12">
          <table class="tg" style="width:100%;">
            <thead>
              <tr class="bgg titulos" style="font-weight:bold;">
                <th class="tg-0lax">PACK</th>
                <th class="tg-0lax">QUANTITY</th>
                <th class="tg-0lax">DESCRIPTION</th>
                <th class="tg-0lax">SIZE</th>
                <th class="tg-0lax">PU</th>
                <th class="tg-0lax">TTL</th>
              </tr>
            </thead>
            <tbody>
              <!-- primer renglon por defecto -->
              <tr>
                <td class="tg-0lax"></td>
                <td class="tg-0lax"></td>
                <td class="tg-0lax"></td>
                <td class="tg-0lax"></td>
                <td class="tg-0lax"></td>
                <td class="tg-0lax"></td>
              </tr>
              <!-- iterable -->
              <tr>
                <td class="tg-0lax">3</td>
                <td class="tg-0lax"></td>
                <td class="tg-0lax"></td>
                <td class="tg-0lax"></td>
                <td class="tg-0lax"></td>
                <td class="tg-0lax"></td>
              </tr>
              <tr>
                <td class="tg-0lax"></td>
                <td class="tg-0lax"></td>
                <td class="tg-0lax"></td>
                <td class="tg-0lax"></td>
                <td class="tg-0lax"></td>
                <td class="tg-0lax"></td>
              </tr>
            </tbody>
          </table>
        </v-col>
      </v-row>
    </div>
  </v-container>
</template>
<script>
import { mapActions, mapState } from "vuex";
import moment from "moment";
moment.locale("es");
export default {
  data() {
    return {
      row: "",
      elementos: [
        { cantidad: 1, descripcion: "das", descaran: "das", critorig: "das", paisorig: "das" },
        { cantidad: 2, descripcion: "das", descaran: "das", critorig: "das", paisorig: "das" },
        { cantidad: 3, descripcion: "das", descaran: "das", critorig: "das", paisorig: "das" },
        { cantidad: 4, descripcion: "das", descaran: "das", critorig: "das", paisorig: "das" },
        { cantidad: 5, descripcion: "das", descaran: "das", critorig: "das", paisorig: "das" }
      ],
      headers: [
        {
          text: "CANTIDAD",
          align: "center",
          sortable: false,
          value: "cantidad"
        }
      ]
    };
  },
  mounted() {
    console.log(this.infoTMEC);
  },
  computed: {
    ...mapState("documentosInternacional", {
      //infoDocumentoCommercialInvoice
      infoTMEC: state => state.infoDocumentoTMEC
    })
  }
};
</script>
<style lang="css" scoped>

.titulos {
  font-weight: bold;
  font-size: 18px;
}
.subtitulos {
  font-size: 18px;
}

.smltrs {
  font-size: 8px;
}
.textos {
  font-weight: bold;
  font-size: 12px;
}

.textos .v-radio .v-label {
  font-size: 8px;
}

.bgg{
background-color: #d9d9d9;
}

.tg {
  border-collapse: collapse;
  border-spacing: 0;
}
.tg td {
  border-color: black;
  border-style: solid;
  border-width: 1px;
  font-family: Arial, sans-serif;
  font-size: 14px;
  overflow: hidden;
  padding: 10px 5px;
  word-break: normal;
}
.tg th {
  border-color: black;
  border-style: solid;
  border-width: 1px;
  font-family: Arial, sans-serif;
  font-size: 14px;
  /* font-weight: normal; */
  overflow: hidden;
  padding: 5px 5px;
  word-break: normal;
}
.tg .tg-0pky {
  border-color: inherit;
  text-align: left;
  vertical-align: top;
}
</style>
